export async function apiFetch(url, { method = 'GET', headers = {}, body, json = true } = {}, { retries = 2, retryDelay = 400 } = {}) {
  let lastErr;
  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      const res = await fetch(url, { method, headers, body });
      if (!res.ok) {
        const text = await safeText(res);
        throw new Error(`API ${method} ${url} failed: ${res.status} ${res.statusText} ${text || ''}`);
      }
      return json ? await res.json() : await res.text();
    } catch (e) {
      lastErr = e;
      if (attempt < retries) await new Promise(r => setTimeout(r, retryDelay));
    }
  }
  throw lastErr;
}

async function safeText(res) { try { return await res.text(); } catch { return ''; } }

export const api = {
  get: (url, params = {}, opts = {}) => {
    const qs = new URLSearchParams(Object.entries(params).filter(([,v]) => v !== undefined && v !== null)).toString();
    const full = qs ? `${url}?${qs}` : url;
    return apiFetch(full, { method: 'GET' }, opts);
  },
  postJson: (url, data, opts = {}) => apiFetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) }, opts),
  putJson: (url, data, opts = {}) => apiFetch(url, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) }, opts),
  postForm: (url, formData, headers = {}, opts = {}) => apiFetch(url, { method: 'POST', headers, body: formData }, opts),
  putForm: (url, formData, headers = {}, opts = {}) => apiFetch(url, { method: 'PUT', headers, body: formData }, opts),
  delete: (url, headers = {}, opts = {}) => apiFetch(url, { method: 'DELETE', headers }, opts),
};

